import { useEffect, useState } from "react";
import { getData } from "../../../../../services";
import { revenueBreakdownOverTimeChartLines, revenueGraphFooter } from "../../../constants";
import { NoDataCard } from "../../../../../components/parts";
import { ShaDowBox } from "../../../../../components/boxes";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { CustomStackedAreaChart } from "../../../../../components/charts/CustomStackedAreaChart";
import { CustomGraphFooter } from "../../../../../components/parts/customGraphFooter";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  areaChart: {
    marginTop: `${theme.spacing(5.25)}px`,
    height: "240px",
  },
}));

export const RevenueBreakdownOverTimeComponent = ({
  buildingId,
  complexId,
  title = "Revenues Breakdown Over Time",
}) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  let url = `/praas/v2/buildings/properties/revenue-breakdown/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/revenue-breakdown/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/revenue-breakdown/`;
  }
  useEffect(() => {
    getData(url, (results) => {
      setChartData(
        results.map((item) => {
          const date = new Date(item.date);
          const potentialRevenue = item.actual_power_revenue + item.tenants_rebate || 0;
          const rentalRevenue = item.rental_revenue || 0;
          const tenantsRebate = item.tenants_rebate || 0;
          const actualPotentialRevenue = item.actual_power_revenue || 0;

          return {
            x: `${date.getUTCFullYear()}-${date.getMonth() + 1}`,
            potential_power_rev: potentialRevenue,
            actual_power_rev: actualPotentialRevenue,
            tenants_rebate: tenantsRebate,
            rental_revenue: rentalRevenue,
            total_revenue:
              potentialRevenue + actualPotentialRevenue + tenantsRebate + rentalRevenue,
          };
        })
      );
    });

    return () => setChartData([]);
  }, []);

  if (!chartData.length)
    return (
      <NoDataCard
        title={title}
        footerNames={[
          "Potential power revenue",
          "Actual power revenue",
          "Tenants rebate",
          "Rental revenue",
        ]}
      />
    );

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Box style={{ marginTop: 56, position: "relative" }}>
          <Box className={classes.consumptionBlock}></Box>
          {chartData.length ? (
            <CustomStackedAreaChart
              data={chartData}
              areas={revenueBreakdownOverTimeChartLines}
              ticks={chartData.map((dataPoint) => dataPoint.x)}
              filledArea={"tenants_rebate"}
            />
          ) : null}
          <CustomGraphFooter items={revenueGraphFooter} />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
